"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * @Author: Lanren
 * @Date: 2021-08-04 10:14:44
 * @LastEditTime: 2022-03-18 10:10:08
 * @LastEditors: Lanren
 * @Description: ______
 * @FilePath: \sdk-admin\src\lang\zh.js
 * --------
 */
var _default = {
  route: {
    dashboard: '首页',
    app_admin: '应用管理',
    system_setting: '系统设置',
    user_admin: '用户管理',
    role_admin: '角色管理',
    operation_log: '操作日志',
    login_log: '登录日志'
  },
  navbar: {
    dashboard: '首页',
    logOut: '退出登录'
  },
  login: {
    title: 'SSO系统',
    logIn: '登录',
    mobile: '账号',
    username: '账号',
    password: '密码'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  }
};
exports.default = _default;